import {createSlice} from '@reduxjs/toolkit';

export interface MapState {
  layer: {
    traffic: boolean;
    weather: boolean;
    pirep: boolean;
    airport: boolean;
    notam: boolean;
    fir: boolean;
  };
  weather: any[];
}

const initialState: MapState = {
  layer: {
    traffic: true,
    weather: true,
    pirep: true,
    airport: true,
    notam: true,
    fir: false
  },
  weather: []
};

const mapSlice = createSlice({
  name: 'mapSlice',
  initialState,
  reducers: {
    setLayer: (state, action) => {
      state.layer = {
        ...state.layer,
        ...action.payload
      };
    },
    setWeather: (state, action) => {
      state.weather = action.payload;
    }
  }
});

export const {setLayer, setWeather} = mapSlice.actions;
export default mapSlice.reducer;
